import { computed, ref, watch } from "vue";
import { useRoute, RouteLocationNormalizedLoaded, useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { ElMessage } from 'element-plus'
import { Base64 } from 'js-base64'
import Cookies from 'js-cookie';
import {
  apiGameRoles,
  apiGameServerList,
  apiGameSubList,
  apiGameGetRiInfo,
  apiGetUserAllRoles
} from '@/api/gameApi'
import { apiGameGetPhoneCode, apiGameGetPhoneLogin, apiGameRoleConfirmRole } from '@/api/goodsApi'
import { GameServerItemType } from '@/@types/types'
import { useAuthStore } from '@/store/modules/auth'
import { UseReportData } from '@/hooks/useReportData'
import { GAME_FORM_DATA } from '@/utils/constances'
import { GameSubItemType, GlobalLoginMethod, GlobalThirdPartyRole } from '@/api/types/gameTypes'
import { useCommonStatus } from '@/store/modules/commonStaus'
import { useGameStore } from '@/store/modules/game'
import { useLanguageStore } from '@/store/modules/language'
import { CommonConstants } from '@/common/constants'
import eventBus, { COMMON_EVENT_NAME } from '@/utils/eventBus'
import { useDevice } from '@/hooks/useDevice'
import i18n from '@/i18n'
import { useGoodsStore } from '@/store/modules/goodsStore'
import { UseMallHooks } from '@/views/mall/modules/useMallHooks'
import { ShowToast } from '@/views/mall/components/AtToast/toast'
import { showTipModal } from "@/views/mall/components/tipModal/index";
import { useVoucherStore } from "@/store/modules/voucher";
import { useVerifyCodeStore } from "@/store/modules/useVerifyCode";

export const UseVerifyAccount = () => {
  const { loginType, isChecked, formData, verifyRole, subList, currentRoleList, agrVisible } =
    storeToRefs(useAuthStore())

  const route = useRoute()
  const router = useRouter()
  const verifyLoading = ref(false)
  const { currentGameId, currentGameConfig } = storeToRefs(useGameStore())
  const { currentCountry } = storeToRefs(useLanguageStore())
  const { setPreCheckList } = useGameStore()
  const { isIOS, isAndroid, isWeixin, isMobileReal } = useDevice()
  const { setPayVisible } = useGoodsStore()
  const { clearCartGoods } = UseMallHooks()

  const serverList = ref<GameServerItemType[]>()
  const {
    setAuthVisible,
    setVerifyRole,
    setFormData,
    setThirdPartyLoginSession,
    clearThirdPartyLoginSession
  } = useAuthStore()
  const { loadMoyuJsSdk, setGuideVisible, setAuthLoginTipsVisible } = useCommonStatus()
  const { isMoyuApp, phoneAccountList, visibleSubList, visiblePhoneList } = storeToRefs(useCommonStatus())
  const { $customEvent } = UseReportData()
  const { freshVoucher } = useVoucherStore()

  const { timer, count } = storeToRefs(useVerifyCodeStore())

  // 手机验证码
  const roleIds = ref('')
  const roleList = ref<any[]>([])

  const isShowAutoLogin = computed(() => {
    const { isShowAutoLogin, wechatInnerUrlIOS, wechatOuterUrlIOS, wechatOuterUrlAND } =
      currentGameConfig.value

    if(isMoyuApp.value) {
      return false
    }

    if (!(isShowAutoLogin && isMobileReal.value)) return false

    if (isIOS()) {
      return Boolean((wechatInnerUrlIOS?.length || 0) > 0 || (wechatOuterUrlIOS?.length || 0) > 0)
    }

    if (isAndroid.value) {
      return Boolean((wechatOuterUrlAND?.length || 0) > 0)
    }

    return false
  })

  // 获取区服列表
  const getServerList = async () => {
    const params = {
      mall_game_id: currentGameConfig.value.id
    }
    const res = await apiGameServerList(params)
    if (res.code === 0 && res.data) {
      if (!formData.value.server_id) {
        formData.value.server_id = res.data[0]?.server_id || ''
      }
      serverList.value = res.data
      if (verifyRole.value.server_id) {
        formData.value.server_id = verifyRole.value.server_id
      }
    }
  }

  const getRoleList = async () => {
    const res = await apiGameRoles({})
    if (res.code !== 0) return
    roleList.value = res.data as any[]
  }

  const onKeyUpRoleId = () => {
    formData.value.role_id = formData.value.role_id.replace(/\D/g, '')
  }

  // 手机号登录
  const handleVerifyCode = () => {
    $customEvent('wm_click_phone_login', {})
    loginType.value = 'phone'
    if (!isChecked.value) {
      agrVisible.value = true
      return
    }
    onVerifyPhone()
  }

  // 验证手机登录
  const onVerifyPhone = async () => {
    if(!formData.value.mall_user_account) {
      ElMessage.warning('请输入手机号')
      return
    }
    if(!CommonConstants.PHONE_REGEX_SIMPLE.test(formData.value.mall_user_account)) {
      ElMessage.warning('请输入正确的手机号')
      return
    }
    if(!formData.value.verifyCode) {
      ElMessage.warning('请输入验证码')
      return
    }
    // 判断验证码是否是4未存数字
    if(!/^\d{4}$/.test(formData.value.verifyCode)) {
      ElMessage.warning('请输入正确的验证码')
      return
    }

    $customEvent('sms_enter_verify_code', {
      type: 1,
      phone: formData.value.mall_user_account,
      code: formData.value.verifyCode
    })
    $customEvent('h5_l_common_login_start', { type: 'phone', ...formData.value })

    const params = {
      mall_game_id: currentGameId.value,
      mall_user_account: formData.value.mall_user_account,
      verifyCode: formData.value.verifyCode
    }
    verifyLoading.value = true
    const res = await apiGameGetPhoneLogin(params)
    verifyLoading.value = false

    // 处理手机异常
    if (res.code === -22) {
      showTipModal('-22')
      $customEvent('wm_verify_result', {
        login_type: loginType.value,
        result: 0,
        msg: res.msg,
        up_position: 'phoneLogin',
        ...formData.value
      })
      $customEvent('h5_l_common_login_end', { type: 'phone', result: 0,  msg: res.msg })
      $customEvent('h5_l_backlogmsg_to_client', {
        type: 1,
        phone: formData.value.mall_user_account,
        code: formData.value.verifyCode,
        is_success: 0,
        msg: res.msg,
      })
      return
    }

    if (res.code === 0 && res.data.length) {
      if (res.data && res.data.length > 1) {
        visiblePhoneList.value = true
        phoneAccountList.value = res.data
      } else {
        Object.assign(formData.value, res.data[0])
        onVerify()
      }
      $customEvent('h5_l_common_login_end', { type: 'phone', result: 1,  msg: res.msg })
      $customEvent('h5_l_backlogmsg_to_client', {
        type: 1,
        phone: formData.value.mall_user_account,
        code: formData.value.verifyCode,
        is_success: 1
      })
    } else {
      // 主动处理错误 -21异常被统一拦截 需要单独处理
      ElMessage({
        message: res.msg,
        type: 'info'
      })
      $customEvent('h5_l_backlogmsg_to_client', {
        type: 1,
        phone: formData.value.mall_user_account,
        code: formData.value.verifyCode,
        is_success: 0,
        msg: res.msg,
      })
      $customEvent('wm_verify_result', {
        login_type: loginType.value,
        result: 0,
        msg: res.msg,
        up_position: 'phoneLogin',
        ...formData.value
      })
      $customEvent('h5_l_common_login_end', { type: 'phone', result: 0,  msg: res.msg })
    }
  }

  // 通过角色反查账号
  const getRoleListByAccount = async () => {
    const gameAccountInfos = JSON.parse(localStorage.getItem('gameAccountInfos') || '{}')
    const accountList = gameAccountInfos[route.path]

    const findItem =
      accountList &&
      accountList.length &&
      accountList.find(
        (item: any) =>
          item.dataList &&
          item.dataList.findIndex(
            (data: any) =>
              data.server_id === verifyRole.value.server_id &&
              data.role_id === verifyRole.value.role_id
          ) > -1
      )
    if (!findItem) {
      const res = await apiGetUserAllRoles({
        mall_game_id: currentGameId.value
      })
      if (res.code === 0) {
        // 将角色信息存储到本地
        if (accountList) {
          // 找一下mall_user_account是否存在
          const findIndex = accountList.findIndex(
            (item: any) => item.mall_user_account === res.data.mall_user_account
          )
          // 如果有, 将dataList合并，再去重
          if (findIndex > -1) {
            accountList[findIndex].dataList = accountList[findIndex].dataList.concat(
              res.data.dataList
            )
            // 按照cpUid去重
            const tempDataList = accountList[findIndex].dataList
            const obj: any = {}
            const newDataList = tempDataList.reduce((cur: any, next: any) => {
              obj[`${next.server_id}-${next.role_id}`]
                ? ''
                : (obj[`${next.server_id}-${next.role_id}`] = true && cur.push(next))
              return cur
            }, [])
            accountList[findIndex].dataList = sortCurrentRole(
              newDataList,
              verifyRole.value.server_id,
              verifyRole.value.role_id
            )

            gameAccountInfos[route.path] = accountList
            localStorage.setItem('gameAccountInfos', JSON.stringify(gameAccountInfos))
          } else {
            const sortDataList = sortCurrentRole(
              res.data.dataList,
              verifyRole.value.server_id,
              verifyRole.value.role_id
            )
            gameAccountInfos[route.path].unshift({
              ...res.data,
              dataList: sortDataList
            })
            localStorage.setItem('gameAccountInfos', JSON.stringify(gameAccountInfos))
          }
        } else {
          const sortDataList = sortCurrentRole(
            res.data.dataList,
            verifyRole.value.server_id,
            verifyRole.value.role_id
          )
          gameAccountInfos[route.path] = []
          gameAccountInfos[route.path].push({
            ...res.data,
            dataList: sortDataList
          })
          localStorage.setItem('gameAccountInfos', JSON.stringify(gameAccountInfos))
        }

        currentRoleList.value = gameAccountInfos[route.path]
      }
    } else {
      currentRoleList.value = accountList
    }
  }

  // 删除某个账号，更新本地缓存，返回现在最新的账号列表
  const deleteAccount = (account: any) => {
    const gameAccountInfos = JSON.parse(localStorage.getItem('gameAccountInfos') || '{}')
    const accountList = gameAccountInfos[route.path]
    if(!accountList) {
      return []
    }
    const findIndex = accountList.findIndex(
      (item: any) => item.mall_user_account === account.mall_user_account
    )
    if (findIndex > -1) {
      accountList.splice(findIndex, 1)
      gameAccountInfos[route.path] = accountList
      localStorage.setItem('gameAccountInfos', JSON.stringify(gameAccountInfos))
    }
    currentRoleList.value = accountList
    return accountList
  }

  // 将当前角色顺序放到第一位
  const sortCurrentRole = (roleList: any[], serverId: string, roleId: string) => {
    const currentRole = roleList.find(
      (item: any) => item.server_id === serverId && item.role_id === roleId
    )
    if (currentRole) {
      const result = roleList.filter(
        (item: any) => item.server_id !== serverId || item.role_id !== roleId
      )
      result.unshift(currentRole)
      return result
    }
    return roleList
  }

  // 选择角色后验证角色登录
  const handleVerifyRole = async (role: any, type?: string) => {
    Object.assign(formData.value, role)
    loginType.value = 'change_history'
    const res = await onVerify()
    if (res && type && type === 'switch_role') {
      $customEvent('wm_switch_role', {})
    }
    return res
  }

  // 获取验证码
  const handleGetCode = async () => {
    if (timer.value) {
      return
    }
    if (!formData.value.mall_user_account) {
      ElMessage.warning('请输入手机号')
      return
    }
    if(!CommonConstants.PHONE_REGEX_SIMPLE.test(formData.value.mall_user_account)) {
      ElMessage.warning('请输入正确的手机号')
      return
    }
    $customEvent('wm_click_get_ver_code', {})
    $customEvent('call_click_authcode', {
      phone: formData.value.mall_user_account,
      type: 1
    })
    const res = await apiGameGetPhoneCode({
      mall_game_id: currentGameId.value,
      mall_user_account: formData.value.mall_user_account
    }).catch((err) => {
      $customEvent('call_click_authcode_result', {
        type: 1, is_success: 0, msg: err?.message || '网络错误', phone: formData.value.mall_user_account
      })
    })

    $customEvent('call_click_authcode_result', {
      type: 1, is_success: res.code === 0 ? 1 : 0, msg: res?.message || '网络错误', phone: formData.value.mall_user_account
    })

    if (res.code === 0) {
      startTime()
    }
  }

  // 点击切换角色
  const handleChangeRole = (role: any) => {
    if (
      role.server_id === verifyRole.value.server_id &&
      role.role_id === verifyRole.value.role_id
    ) {
      return
    }
    loginType.value = 'change_history'
    handleVerifyRole(role, 'switch_role')
  }

  const startTime = () => {
    timer.value = setInterval(() => {
      count.value--
      if (count.value <= 0) {
        clearInterval(timer.value)
        timer.value = null
        count.value = 60
      }
    }, 1000)
  }

  // 验证手机号码
  const onKeyUpVerifyPhone = () => {
    formData.value.mall_user_account = formData.value.mall_user_account.replace(/\D/g, '')
  }

  // 获取小号列表
  async function getSubList(route: RouteLocationNormalizedLoaded) {
    const params: any = {
      mall_game_id: currentGameId.value,
      ...formData.value,
    }
    if (isMoyuApp.value) {
      // 摸鱼社传一个登录类型
      params.loginType = 4
    } else {
      params.loginType = 3
    }
    subList.value = []
    const res = await apiGameSubList(params)
    if (res.code !== 0) {
      return {
        code: res.code,
        msg: res.msg
      }
    }

    subList.value = res.data
    const localTokens = JSON.parse(localStorage.getItem('tokens') || '{}')
    localTokens[route.path] = res?.access_token || ''
    localStorage.setItem('tokens', JSON.stringify(localTokens))
    return {
      code: res.code,
      msg: res.msg
    }
  }

  // 确认角色
  async function onConfirmRole(role: GameSubItemType | undefined) {
    if (!role) {
      return {
        code: -1,
        msg: '无角色信息'
      }
    }
    const params = {
      mall_game_id: currentGameId.value,
      server_id: role.server_id,
      role_id: role.role_id,
      cpUid: role.cpUid,
      payRegion: currentCountry.value.key
    }
    const res = await apiGameRoleConfirmRole(params)
    if (res.code !== 0) {
      return {
        code: res.code,
        msg: res.msg
      }
    }
    verifyRole.value = res.data
    return {
      code: res.code,
      msg: res.msg
    }
  }

  // 判断是否可以根据 ri 登录，如果不能就获取本地缓存设置
  const setRoleInfoByPath = async () => {
    // 先判断一下url是否带有ri参数，如果有则直接拉取角色信息
    const { query } = route
    if (query.ri) {
      const params = {
        mall_game_id: currentGameConfig.value.id,
        link_url_code: query.ri as string
      }
      const res = await apiGameGetRiInfo(params)
      if (res.code === 0 && res.data) {
        await onSwitchVerify(false)
        setFormData(res.data)
        loginType.value = 'linkLogin'
        onVerify()
      } else {
        await setInfos()
      }
    } else {
      await setInfos()
    }
  }

  // 根据本地缓存的游戏角色信息，设置当前角色信息
  const setInfos = async () => {
    const roleInfo = localStorage.getItem('gameRoleInfo')
    if(!roleInfo) {
      return
    }
    if (roleInfo) {
      const data = JSON.parse(roleInfo)[route.path as string]
      if (data) {
        setVerifyRole(data)
      } else {
        setVerifyRole({
          cUid: '',
          cpUid: '',
          cp_ext: '',
          game_role_bind_time: '',
          game_role_status: 0,
          levelFlag: false,
          mall_game_id: 0,
          game_name: '',
          mall_game_role_id: 0,
          mall_user_account: '',
          role_name: '',
          server_id: '',
          server_name: '',
          role_id: '',
          cid: '',
          vipName: '',
          nextAmount: 0,
          benefitNotes: [],
          benefitNum: 0
        })
      }
    }
    const gameFormData = localStorage.getItem(GAME_FORM_DATA)
    if (gameFormData && Object.keys(JSON.parse(gameFormData)).length > 0) {
      const data = JSON.parse(gameFormData)[route.path as string]
      if (data) {
        setFormData(data)
        // const res = await getSubList(route)
        $customEvent('wm_verify_result', {
          login_type: 'cacheLogin',
          result: 1,
          msg: "缓存登录成功",
          up_position: 'cacheLogin',
          ...formData.value
        })
        $customEvent('wm_role_verification', {
          login_type: 'cacheLogin',
          up_position: 'catchLogin',
          ...formData.value
        })
      }
    }
  }

  // 清空绑定信息
  function clearVerifyRole() {
    const initRole = {
      cUid: '',
      cpUid: '',
      cp_ext: '',
      game_role_bind_time: '',
      game_role_status: 0,
      mall_game_id: 0,
      game_name: '',
      mall_game_role_id: 0,
      mall_user_account: '',
      role_name: '',
      server_id: '',
      server_name: '',
      role_id: '',
      cid: '',
      vipName: '',
      nextAmount: 0,
      levelFlag: false,
      benefitNum: 0,
      benefitNotes: []
    }
    setPreCheckList({})
    verifyRole.value = initRole
    formData.value.role_id = ''
    formData.value.cpUid = ''
    const gameFormData = localStorage.getItem(GAME_FORM_DATA)
    const res = localStorage.getItem('gameRoleInfo')
    // 账号信息
    const accountList = JSON.parse(localStorage.getItem('gameAccountInfos') || '{}')
    if (res) {
      try {
        const roleInfoObj = JSON.parse(res)
        if (roleInfoObj[window.globalRoute.path]) {
          delete roleInfoObj[window.globalRoute.path]
        }
        localStorage.setItem('gameRoleInfo', JSON.stringify(roleInfoObj))
      } catch (e) {
        console.log(e)
      }
    }
    if (gameFormData) {
      try {
        const gameFormDataObj = JSON.parse(gameFormData)
        if (gameFormDataObj[window.globalRoute.path]) {
          delete gameFormDataObj[window.globalRoute.path]
        }
        localStorage.setItem(GAME_FORM_DATA, JSON.stringify(gameFormDataObj))
      } catch (e) {
        console.log(e)
      }
    }
    if (accountList[window.globalRoute.path]) {
      delete accountList[window.globalRoute.path]
      localStorage.setItem('gameAccountInfos', JSON.stringify(accountList))
    }
    const localTokens = JSON.parse(localStorage.getItem('tokens') || '{}')
    delete localTokens[window.globalRoute.path]
    localStorage.setItem('tokens', JSON.stringify(localTokens))
    clearThirdPartyLoginSession()
  }

  // 全球第三方账号选择角色后，复用当前角色登录/确认链路
  const handleThirdPartyRole = async (payload: {
    role: GlobalThirdPartyRole
    cuid: string
    method: GlobalLoginMethod
    roles?: GlobalThirdPartyRole[]
  }) => {
    setThirdPartyLoginSession({
      mallGameId: currentGameId.value,
      cuid: payload.cuid,
      method: payload.method,
      roles: payload.roles || [payload.role]
    })
    loginType.value = 'third_party'
    formData.value.mall_user_account = payload.cuid
    formData.value.server_id = payload.role.server_id
    formData.value.role_id = payload.role.role_id
    formData.value.cpUid = payload.role.cpUid
    return onVerify()
  }

  // 角色ID验证登录
  const handleVerifyMiddle = () => {
    $customEvent('wm_click_role_login', {})
    loginType.value = 'verify'

    if (CommonConstants.IS_AREA === 'cn') {
      if (!isChecked.value) {
        agrVisible.value = true
        return
      }
    }
    onVerify()
  }

  // 验证角色，拉取小号列表
  const onVerify = async () => {
    console.log("触发了 onVerify")
    $customEvent('wm_click_verify_role', { ...formData.value, loginType: 1 })

    verifyLoading.value = true
    // 摸鱼社内的创魔选择角色就是小号列表，直接确认角色
    if (isMoyuApp.value && route.path === '/cncm') {
      const result = await handleConfirmRole(formData.value as any)
      verifyLoading.value = false
      return result
    }
    console.log("触发了 onVerify2")
    const res = await getSubList(route)
    if (res.code !== 0) {
      const eParams = {
        ...formData.value,
        login_type: loginType.value
      }
      verifyLoading.value = false
      $customEvent('wm_verify_result', {
        ...eParams,
        result: 0,
        msg: res.msg,
        up_position: 'getSubList'
      })
      // 普通业务错误由 request 层统一提示；网络/请求异常不会经过 errorToast，这里补兜底。
      if (res.code === -1000) {
        ElMessage.warning(i18n.global.t('i18n-role-login-failed'))
      }
      return false
    }
    console.log("触发了 onVerify3", subList.value)
    // 第三方登录已经选定了 CP 角色，优先在 roleLogin 返回中匹配该角色并直接确认
    if (loginType.value === 'third_party') {
      const matchedRole = subList.value.find(
        item => item.role_id === formData.value.role_id && item.server_id === formData.value.server_id
      )
      if (matchedRole) {
        const result = await handleConfirmRole(matchedRole, 'third_party')
        verifyLoading.value = false
        return result
      }

      // 三方登录已经明确选择过角色，不能在匹配失败时回退到其他角色列表，避免登录到错误角色。
      ElMessage.warning(i18n.global.t('i18n-role-login-failed'))
      clearThirdPartyLoginSession()
      verifyLoading.value = false
      return false
    }
    // 只有一个小号的时候，自动确认角色
    if (subList.value.length === 1) {
      const result = await handleConfirmRole(subList.value[0], loginType.value)
      verifyLoading.value = false
      return result
    }
    visibleSubList.value = true
    verifyLoading.value = false
    return true
  }

  // 切换账号
  const onSwitchVerify = async (showCard: boolean = true) => {
    const eParams = {
      ...formData.value
    }
    $customEvent('wm_login_switch', eParams)
    roleIds.value = ''
    clearVerifyRole()
    clearCartGoods()
    if (isMoyuApp.value) {
      await loadMoyuJsSdk(route.path, () => {
        console.log(111)
      })
    }

    // 只有清空的时候再刷新别的
    if (showCard) {
      eventBus.emit(COMMON_EVENT_NAME.REFRESH_GOODS_LIST)
      eventBus.emit(COMMON_EVENT_NAME.UPDATE_ACTIVITY)
      eventBus.emit(COMMON_EVENT_NAME.INIT_VOUCHER_DATA)

      const webSource = route.query?.webSource
      const path = window.location.origin + window.location.pathname
      const baseUrl = CommonConstants.IS_CN ? `${path}#${currentGameConfig.value.path}` : `${path}`
      if (webSource === '1') {
        window.location.href = baseUrl
        setTimeout(() => {
          setAuthVisible(true)
        }, 100)
      }
      if (webSource === '2') {
        window.location.href = baseUrl

        setTimeout(() => {
          setPayVisible(true)
        }, 100)
      }
    }
  }

  // 确认角色（最终登录接口）
  const handleConfirmRole = async (role: GameSubItemType, type = 'autoVerify') => {
    const res = await onConfirmRole(role)
    const eParams: any = {
      ...formData.value,
      login_type: type,
      up_position: 'confirmRole'
    }

    $customEvent('wm_verify_result', {
      result: res.code === 0 ? 1 : 0,
      ...eParams,
      msg: res.msg,
      up_position: 'confirmRole'
    })
    // 处理账号异常
    if (res.code === -21) {
      showTipModal('-21')
      visibleSubList.value = false
      return false
    }

    if (res.code !== 0) {
      // confirmRole 关闭了 request 层 errorToast，这里必须给用户明确反馈。
      ElMessage.warning(
        res.code === -1000
          ? i18n.global.t('i18n-role-login-failed')
          : (res.msg || i18n.global.t('i18n-role-login-failed'))
      )
      return false
    }
    if (type === 'autoVerify') {
      $customEvent('wm_auto_login_success', {})
    }
    $customEvent('wm_role_verification', eParams)

    const refreshVoucherPromise = freshVoucher({
      mall_game_id: currentGameId.value as number,
      server_id: verifyRole.value.server_id,
      cpUid: verifyRole.value.role_id
    })
    // 直购链路后面会立即拉起收银台，必须等角色刷新完成，
    // 保证 confirmRole -> flushConfirm -> cashier 严格串行。
    if (type === 'directBuyLogin') {
      await refreshVoucherPromise
    }

    Cookies.set('server_id', verifyRole.value.server_id, { expires: 14, path: '/' });
    Cookies.set('role_id', verifyRole.value.role_id, { expires: 14, path: '/' });

    if (loginType.value === 'third_party') {
      $customEvent('login_success', {
        login_method: useAuthStore().thirdPartyLoginMethod
      })
    }

    // 根据游戏ID保存当前游戏的角色信息
    const gameFormData = localStorage.getItem(GAME_FORM_DATA)
    const localRoleInfo = JSON.parse(localStorage.getItem('gameRoleInfo') || '{}')
    localRoleInfo[route.path] = verifyRole.value
    localStorage.setItem('gameRoleInfo', JSON.stringify(localRoleInfo))
    const tempFormData = gameFormData ? JSON.parse(gameFormData) : {}
    tempFormData[route.path] = formData.value
    localStorage.setItem(GAME_FORM_DATA, JSON.stringify(tempFormData))

    console.log('关闭登录弹窗')
    setAuthVisible(false)
    eventBus.emit(COMMON_EVENT_NAME.ACTIVITY_TIPS)
    eventBus.emit(COMMON_EVENT_NAME.REFRESH_GOODS_LIST)
    eventBus.emit(COMMON_EVENT_NAME.UPDATE_ACTIVITY)

    ShowToast({
      title: `${i18n.global.t('i18n-login-success-desc')}：`,
      roleName: verifyRole.value.role_name,
      roleId: verifyRole.value.role_id,
      serverName: currentGameConfig.value.isShowServer ? verifyRole.value.server_name : ''
    })

    // 如果有ri，将url的ri参数去掉, 成功后将url上会再登录的字段清理掉
    router.replace({
      query: {
        ...route.query,
        roleId: undefined,
        serverId: undefined,
        code: undefined,
        state: undefined,
        device_id: undefined,
        expires_in: undefined,
        ext_id: undefined,
        type: undefined,
        error: undefined,
        error_description: undefined,
      }
    })
    // if (route.query.ri) {
    //   router.replace({
    //     query: {
    //       ...route.query,
    //       roleId: undefined,
    //       serverId: undefined,
    //     }
    //   })
    // } else {
    //   router.replace({
    //     query: {
    //       ...route.query,
    //       roleId: undefined,
    //       serverId: undefined,
    //     }
    //   })
    // }
    return res
  }

  // 在摸鱼社内切换角色
  const onChangeRole = async (e: any) => {
    const ids = e.split('&')
    formData.value.server_id = ids[0] as string
    formData.value.role_id = ids[1] as string
    formData.value.cpUid = ids[2] as string
  }

  const getAutoLoginUrl = () => {
    let url: string[] = []
    if (isIOS()) {
      if (isWeixin.value) {
        url = currentGameConfig.value?.wechatInnerUrlIOS as string[]
      } else {
        url = currentGameConfig.value?.wechatOuterUrlIOS as string[]
      }
    } else if (isAndroid.value) {
      url = currentGameConfig.value?.wechatOuterUrlAND as string[]
    }
    return url
  }

  const handleToApp = (webSource: 1 | 2 | 3) => {
    // if (formData.value.role_id && formData.value.server_id) {
    //   ElMessage.warning(i18n.global.t('i18n-auto-login-tips'))
    //   return
    // }

    if (isWeixin.value) {
      $customEvent('wm_click_auto_auth_in_wechat', {})
      setGuideVisible(true)
      return
    }
    if (CommonConstants.IS_AREA === 'cn') {
      if (!isChecked.value && webSource !== 3) {
        agrVisible.value = true
        return
      }
    }

    loginType.value = 'autoVerify'

    $customEvent('wm_click_auto_auth', { webSource })
    $customEvent('wm_click_login_type', { type: 3 })


    const schemeArr = getAutoLoginUrl()
    const path = window.location.origin + window.location.pathname

    const baseUrl = CommonConstants.IS_CN
      ? `${path}#${currentGameConfig.value.path}?webSource=${webSource}`
      : `${path}?webSource=${webSource}`
    const encoded = Base64.encode(baseUrl)
    console.log('授权登录URL', `${schemeArr[0]}://cnmall?baseUrl=${encoded}`)
    window.location.href = `${schemeArr[0]}://cnmall?baseUrl=${encoded}`

    setAuthLoginTipsVisible(true)
    // if (webSource === 1) {
    //   setAuthVisible(false)
    // }
  }

  // 点击同意协议
  const handleAgreeAgr = (webSource: 1 | 2) => {
    agrVisible.value = false
    isChecked.value = true
    console.log("触发了")
    if (loginType.value === 'verify') {
      onVerify()
    } else if (loginType.value === 'phone') {
      onVerifyPhone()
    } else {
      handleToApp(webSource)
    }
  }

  const handleDisAgreeAgr = () => {
    agrVisible.value = false
    const eParams: any = {
      ...formData.value,
      login_type: loginType.value,
      up_position: 'agrModal'
    }
    $customEvent('wm_verify_result', {
      result: 0,
      ...eParams,
      msg: '拒绝了用户协议',
      up_position: 'agrModal'
    })
  }

  const clickSwiper = () => {
    if (!verifyRole.value.cpUid) {
      setAuthVisible(true)

      $customEvent('wm_click_banner_open_auth', {})
    }
  }

  watch(() => currentGameConfig.value.usdkId, () => {
    clearInterval(timer.value as number)
    timer.value = null
    count.value = 60
  })

  return {
    isChecked,
    roleIds,
    serverList,
    roleList,
    verifyLoading,
    timer,
    count,
    isShowAutoLogin,
    getServerList,
    getRoleList,
    onChangeRole,
    onVerify,
    handleConfirmRole,
    onSwitchVerify,
    onKeyUpRoleId,
    onConfirmRole,
    getSubList,
    clearVerifyRole,
    handleToApp,
    agrVisible,
    handleAgreeAgr,
    handleVerifyMiddle,
    setRoleInfoByPath,
    clickSwiper,
    onKeyUpVerifyPhone,
    handleGetCode,
    handleVerifyCode,
    handleVerifyRole,
    getRoleListByAccount,
    handleChangeRole,
    handleThirdPartyRole,
    deleteAccount,
    handleDisAgreeAgr
  }
}
